import styled from 'styled-components'

import theme, { breakpoint } from 'style/theme'

export default styled.div`
  background: #fff0e2;
  background-image: linear-gradient(164deg, #fff0e2 3%, #ffffff 59%);

  .banner-block {
    height: 600px;

    .image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .ant-tabs {
    .ant-tabs-nav {
      margin: 0 0 30px 0;
    }
    .ant-tabs-nav::before {
      border-bottom: 3px solid rgba(213, 212, 212, 0.7);
    }
    .ant-tabs-nav {
      .ant-tabs-nav-list {
        width: 100%;

        .ant-tabs-tab {
          width: 100%;
          justify-content: center;
          margin-right: 0;
        }
      }
    }
    .ant-tabs-tab-btn {
      color: ${theme.darkRed};
      font-size: 20px;
    }
    .ant-tabs-ink-bar {
      height: 3px;
      background: ${theme.darkRed};
    }
  }

  .cat-block {
    margin-bottom: 40px;

    .title-cat {
      margin-bottom: 15px;
      color: ${theme.darkRed};
    }
  }

  .article-content {
    padding-top: 40px;
    padding-bottom: 80px;

    > .title-block {
      margin-bottom: 50px;
      text-align: center;
      .subtitle {
        margin-top: 10px;
      }
    }

    .pagination-block {
      display: flex;
      justify-content: center;
      margin-top: 40px;
    }
  }

  @media (max-width: ${breakpoint.lg}) {
    .article-content {
      padding-bottom: 50px;
    }
  }

  @media (max-width: ${breakpoint.md}) {
    .banner-block {
      height: 400px;
    }

    .ant-tabs {
      .ant-tabs-nav {
        .ant-tabs-nav-list {
          width: auto;

          .ant-tabs-tab {
            width: auto;
          }
        }
      }
    }

    .cat-block {
      margin-bottom: 30px;
    }

    .article-content {
      > .title-block {
        margin-bottom: 30px;
      }
    }
  }
`
